import React from 'react';
import { QUALIFICATION_PAGE_TEXT } from './lang';
import { useGetARQualificationNumbers } from './graphql';
import {
  type ManagementCardInfo,
  HomePage,
  Alert,
  Loading,
} from '../../components';

const { AR_HOME_PAGE_TEXT } = QUALIFICATION_PAGE_TEXT;
const ARHomeCards: ManagementCardInfo[] = [
  {
    title: AR_HOME_PAGE_TEXT.QUALIFICATION_CHECK,
    caseName: AR_HOME_PAGE_TEXT.QUALIFICATION_CHECK,
    caseNumber: 0,
    backgroundColor: '#951D1D',
    navLink: `/internal/ar-homepage/ar-process?am=0`,
  },
  {
    title: AR_HOME_PAGE_TEXT.VISA_APPLICATION,
    caseName: AR_HOME_PAGE_TEXT.VISA_APPLICATION,
    caseNumber: 0,
    backgroundColor: '#D96422',
    navLink: `/internal/ar-homepage/ar-process?am=1`,
  },
];

export const AcademicRegistryHomePage: React.FunctionComponent = () => {
  // TODO: Replace with the correct query of numbers
  const { qualificationNumbers, loading, error } = useGetARQualificationNumbers(
    [{}, {}],
  );

  ARHomeCards[0].caseNumber = qualificationNumbers[0];
  ARHomeCards[1].caseNumber = qualificationNumbers[1];

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <HomePage managementCards={ARHomeCards} />
        </>
      )}
    </>
  );
};
